import { render, staticRenderFns } from "./996.vue?vue&type=template&id=5661d7a5&scoped=true&"
import script from "./996.vue?vue&type=script&lang=ts&"
export * from "./996.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661d7a5",
  null
  
)

export default component.exports